import React from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../../utils/mq';
import type { ClubicEmbedProps } from './clubic-embed';
import { PostItemLine } from '../post-item-line';
import { displayDateDiff } from '../../atoms/date/utils';
import { useTranslation } from '../../utils/translation';

const EmbedSectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacer-m);

  border-radius: 10px;
  background: var(--color-alt-4);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  flex: 0 1 auto;
  margin: var(--spacer) 0;
  position: relative;
  top: 0;
  transition: top 0.3s;
  padding: var(--spacer-m);

  ${mq.lte(
    DEVICE_SIZE.LARGE,
    css`
      flex-direction: column;
    `,
  )}
`;

const Label = styled.div`
  color: #99a4ba;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  margin: 0 0 15px;
  text-transform: uppercase;
`;

const ItemsList = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;

const SectionListContainer = ({ label, itemList }: React.PropsWithChildren<ClubicEmbedProps>) => {
  const t = useTranslation();
  const locale = t('locale');

  return (
    <EmbedSectionList>
      <Label>{label}</Label>
      <ItemsList>
        {itemList.map((item) => {
          const date = item?.updatedAt > item?.publishedAt ? item?.updatedAt : item?.publishedAt;
          const dateTimeAgo = displayDateDiff(date, locale);
          const link = {
            href: item.url,
          };

          return (
            <PostItemLine
              id={item.id}
              key={item.id}
              title={item.title}
              commentCount={item.commentsNb}
              image={{ imageId: item.imageId, alt: item.title }}
              date={dateTimeAgo}
              authors={item.authors}
              link={link}
            />
          );
        })}
      </ItemsList>
    </EmbedSectionList>
  );
};

export default SectionListContainer;
